
<template>
  <div class="icon-management" :style="'height:' + conHeight + 'px;'" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="menu-contain">
      <div class="menu">
        <div class="top">
          <el-button icon="el-icon-plus" size="small" type="info" @click="add">添加分组</el-button>
          <div style="height: 10px"></div>
          <div v-for="(item, index) in tableData" :key="index" class="menu-item" >
            <span class="name" v-if="!item.is_edit" @click.stop.prevent="handleLeft(index)">{{ item.paramName }}</span>
            <el-input  maxlength="20" style="width: 220px" max v-model="paramName" v-if="item.is_edit" />
            <div class="operate">
              <span
                class="el-icon-edit-outline i-edit-sty edit"
                style="margin-right: 10px"
                 @click.stop.prevent="edit(item, 0, index)"
                v-if="!item.is_edit"
              ></span>
              <span
                class="el-icon-document-checked i-edit-sty edit"
                style="margin-right: 10px"
                 @click.stop.prevent="edit(item, 1, index)"
                v-if="item.is_edit"
              ></span>
              <span class="el-icon-delete i-edit-sty del"  @click.stop.prevent="delVersion(item.guid,index)"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="contain">
        <div v-for="(item, index) in tableData" :key="index" style="margin-bottom: 10px" :id="'id'+index">
          <div class="title">
            <span></span>{{ item.paramName }}
            <el-button
              v-if="item.isOpenEdit"
              style="position: absolute; right: 100px"
              size="small"
              type="info"
              @click="uploadEdit(index, 2)"
              >取消</el-button
            >
            <el-button
              v-if="!item.isOpenEdit"
              style="position: absolute; right: 30px"
              size="small"
              type="info"
              @click="uploadEdit(index, 0)"
              >编辑</el-button
            >
            <el-button
              v-if="item.isOpenEdit"
              style="position: absolute; right: 30px"
              size="small"
              type="info"
              @click="uploadEdit(index, 1)"
              >保存</el-button
            >
          </div>
          <div class="pic-list" v-if="item.isOpenEdit||item.paramValue&&JSON.parse(item.paramValue)">
            <el-upload
              v-if="item.isOpenEdit"
              name="image"
              class="upload"
              action="#"
              list-type="picture-card"
              :headers="token"
              :http-request="uploadImage"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <div v-for="(el,idx) in item.paramValue&&JSON.parse(item.paramValue)" :key="idx" class="img-desc">
              <el-image  class="img" :src="el.url" fit="contain" :preview-src-list="getUrl(item.paramValue&&JSON.parse(item.paramValue))" />
              <div class="desc">{{el.name}}</div>
              <div >
                <img src="@/assets/images/ic_close.png" @click="delPic(index,idx)" class="del-icon"  v-if="item.isOpenEdit">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      tableData: [],
      conHeight: window.innerHeight - 85,
      dialogVisible: false,
      paramName: '',
      textTitle: '新增分组',
      tableData: [],
      fullscreenLoading: false,
      currentIndex: 0,
      timeId:null,
      listBoxState:false,
    };
  },
  created() {
    this.getList();
  },

  mounted() {
    window.addEventListener('scroll',this.bodyScroll, true);
  },
  beforeDestroy(){
    window.removeEventListener('scroll',this.bodyScroll, true)
  },
  methods: {
    getUrl(list){
      var newList =[];
      list.forEach(item=>{
        newList.push(item.url)
      })
      return newList;
    },
      //页面滚动监听
      bodyScroll(){
        clearTimeout(this.timeId);
            this.timeId = setTimeout(() => {
              this.scrollToTop();
            }, 100);
          },
      // 点击导航菜单，页面滚动到指定位置
      handleLeft(index) {
        this.currentIndex = index;
        this.$el.querySelector(`#id${index}`).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start" // 上边框与视窗顶部平齐。默认值
        });
        this.listBoxState = false;
        let timeId;
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          this.listBoxState = true;
        }, 200);
      },
      // 监听页面元素滚动，改变导航栏选中
      scrollToTop() {
        // 获取视窗高度
        var domHight = document.body.offsetHeight;
        // dom滚动位置
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (this.listBoxState) { //作用是点击导航栏时，延迟这里执行。
          this.tableData.map((v, i) => {
            // 获取监听元素距离视窗顶部距离
            var offsetTop = document.getElementById(`id${i}`).offsetTop;
            // 获取监听元素本身高度
            var scrollHeight = document.getElementById(`id${i}`).scrollHeight;
            // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
            // 则表示页面已经滚动到可视区了。
            if (scrollTop >= offsetTop && scrollTop <= (offsetTop + scrollHeight)) {
              // 导航栏背景色选中
              this.currentIndex = i;
            }
          })
        }
      },
    getList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        bizType: '图标管理',
        paramName: '',
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.tableData.forEach((el) => {
            el.is_edit = false;
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    add() {
      this.textTitle = '新增分组';
      this.paramName = '';
      this.guid = '';
      this.tableData.forEach((item, index) => {
        if (item.is_edit) {
          this.tableData.splice(index);
        }
      });
      this.tableData.push({
        paramName: '',
        is_edit: true,
      });
    },
    edit(detail, type, index) {
      if (type == 0) {
        this.tableData.forEach((item) => {
          item.is_edit = false;
        });
        this.tableData[index].is_edit = true;
        this.guid = detail.guid;
        this.paramName = detail.paramName;
        this.$forceUpdate();
      } else {
        this.updateReqVersion();
      }
    },
    delVersion(guid,index) {
      var self = this;
      if(this.tableData[index].paramValue){
         this.$message.error('分组下存在图标，不允许删除！');
         return
      }else{
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('删除成功');
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
      }
    },
    addReqVersion() {
      var self = this;
      if (!this.paramName) {
        self.$message.error('请输入分组名称');
        return;
      }
      var req = {
        paramName: this.paramName,
        bizType: '图标管理',
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('保存成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.paramName) {
        self.$message.error('请输入分组名称');
        return;
      }
      var req = {
        bizType: '图标管理',
        paramName: this.paramName,
        guid: this.guid,
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('保存成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    uploadImage(file) {
      let self = this;
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
             this.tableData[this.currentIndex].paramValue =  this.tableData[this.currentIndex].paramValue?JSON.parse(this.tableData[this.currentIndex].paramValue):[];
             this.tableData[this.currentIndex].paramValue.push({
               name:file.file.name,
               url:res.data.data,
             })
            this.tableData[this.currentIndex].paramValue  = JSON.stringify(this.tableData[this.currentIndex].paramValue);
            console.log( this.tableData)
          } else {
            self.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    uploadEdit(index, type) {
      let self = this;
      if (type == 1) { //保存
        self.tableData[index].isOpenEdit = false;
        self.updatePic();
        return;
      }
      if(type == 2){//取消
        self.tableData[index].isOpenEdit = true;
        self.getList();
        return;
      } 
      let req = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        bizType: '图标管理',
        paramName: '',
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.tableData.forEach((el) => {
            el.is_edit = false;
            el.isOpenEdit = false;
          });
            self.currentIndex = index;
            if (type == 0) { //编辑
              self.tableData[index].isOpenEdit = true;
            }
          
            this.$forceUpdate();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updatePic(){
      var self = this;
      var tableItem = this.tableData[this.currentIndex];
      var req = {
        bizType: '图标管理',
        paramName: tableItem.paramName,
        paramValue:tableItem.paramValue||'',
        guid: tableItem.guid,
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('保存成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delPic(tabIdx,picIdex){
      var self = this;
      var tableItem = this.tableData[tabIdx];
      var paramValue = JSON.parse(tableItem.paramValue);
      paramValue.splice(picIdex,1);
      tableItem.paramValue = paramValue.length !=0?JSON.stringify(paramValue):null;
      this.tableData[tabIdx] = tableItem;
      this.$forceUpdate();
    }
  },
};
</script>
<style scoped>
.icon-management {
  overflow-y: scroll;
  overflow-x: hidden;
}
.icon-management .top {
  background: #fff;
  text-align: left;
  padding: 10px;
}
.menu-contain {
  margin-top: 15px;
  display: flex;
  margin-left: 15px;
}
.menu {
  width: 300px;
  background: #fff;
  min-height: 600px;
  position: fixed;
}
.contain {
 width: calc(100% - 300px);
 margin-left:310px;
}
.menu-item {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
  align-items: center;
  cursor: pointer;
}
.menu-item .name {
  width: 250px;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.operate span {
  font-size: 18px;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  background: #fff;
  position: relative;
}
.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}
.pic-list {
  height: auto;
  background: #fff;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}
.img-desc{
  width: 168px;
  height: 190px;
}
.pic-list  .img{
  margin-left: 20px;
  width: 150px;
  height: 150px;
   background: rgba(0,0,0,0.06);
  
}
.desc{
  text-align: center;
  margin-bottom: 20px;
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .bread {
  position: fixed;
}
.upload {
  width: 150px;
  height: 150px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  display: none;
}
.img-desc{
  position: relative;
}
.del-icon{
  position: absolute;
  right: -2px;
  top: 0;
  width: 20px;
  height: 20px;
}
.menu-item .del,.menu-item .edit{
  display: none;
}
.menu-item:hover .del{
  display:inline;
}
.menu-item:hover .edit{
  display: inline;
}

</style>